import React, {Component} from 'react'
import {Col, Icon, Row} from 'rsuite'
import _ from 'lodash'

import QuestionNavigationContainer from '../_components/Questions/QuestionNavigationContainer'
import NRTFormStateManager from '../../../../_common/_form/FormStateManager'
import {
    StyledButton,
    StyledQuestionDescription,
    StyledQuestionNavigationContainer
} from '../styled/StyledQuestionComponents'
import QuestionPageHeader from './Questions/QuestionPageHeader'


class Questionary extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {

        const {questions, form, questionsAnswers, currentQuestionNumber, disabledButton, isReview, questionaryInfo} = this.props
        const currentQuestion = questions[currentQuestionNumber]
        const hasAnswers = _.isEmpty(questionsAnswers[currentQuestionNumber]) ? false : questionsAnswers[currentQuestionNumber][currentQuestion.code] !== ''
     
        return (
            <Row>

                {questions &&
                <QuestionPageHeader
                    question={questions[currentQuestionNumber]}
                    hasAnswers={hasAnswers}
                    answers={questionsAnswers && questionsAnswers}
                    saveQuestion={this.props.saveQuestion.bind(this)}
                    savedQuestions={this.props.savedQuestions}
                    isReview={isReview}
                    questionaryInfo={questionaryInfo}
                    previousTriesDTO={this.props.previousTriesDTO}
                />
                }

                <Col md={15}>
                    <Row>

                        <StyledQuestionDescription>
                            <NRTFormStateManager
                                doUnmountInput={false}
                                ref={form => {
                                    this.form = form
                                }}
                                onStateChange={(form) => {
                                    this.props.onFormStateChange(form)
                                }}
                            >
                                {questions && this.props.showQuestion(questions)}

                            </NRTFormStateManager>
                        </StyledQuestionDescription>

                    </Row>
                    <Row>

                        <Col md={12}>
                            <StyledButton
                                appearance="ghost"
                                disabled={disabledButton}
                                onClick={() => this.props.handleQuestionNavigation(currentQuestionNumber - 1)}
                            >
                                <Icon icon='long-arrow-left' size="lg"/> Anterior

                            </StyledButton>
                        </Col>
                        <Col md={12}>
                            <StyledButton
                                color={'green'}
                                appearance="defaut"
                                onClick={() => this.props.handleQuestionNavigation(currentQuestionNumber + 1)}
                            >
                                Próximo <Icon icon='long-arrow-right' size="lg"/>
                            </StyledButton>
                        </Col>

                    </Row>
                </Col>


                <Col md={9}>
                    <StyledQuestionNavigationContainer>
                        <QuestionNavigationContainer
                            title={'Navegação do questionário'}
                            questions={questions && questions}
                            answers={questionsAnswers && questionsAnswers}
                            currentQuestion={currentQuestionNumber}
                            handleNavigation={this.props.handleQuestionNavigation}
                            savedQuestions={this.props.savedQuestions}
                            showSummary={this.props.showSummary}
                            showDefautPage={this.props.showDefautPage}
                            isReview={this.props.isReview}
                            minutes={this.props.minutes}
                            seconds={this.props.seconds}
                            hasTime={this.props.hasTime}
                        />
                    </StyledQuestionNavigationContainer>

                </Col>

            </Row>
        )

    }
}

export default Questionary





// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/Questionary.js